import {NavLink } from "react-router-dom";

function CategoryItem(props) {
    return (<NavLink to="explore.html" className="category-item">
        <img src={props.coverImgSrc} alt="" />

        <div className="content">
            <img src={props.subImgSrc} alt="" />
            <h5>{props.heading}</h5>
        </div>
    </NavLink>);
}

export default CategoryItem;